function DataTableWrapper(tableElem) {
    this.$table = tableElem;
}

DataTableWrapper.prototype.createDtlStmtDefaults = function() {
    var dataTableParams = new DataTableParams();
    
    dataTableParams.responsive = true
    dataTableParams.ordering = true
    dataTableParams.processing = false
    dataTableParams.serverSide = true
    dataTableParams.stateSave = false
    dataTableParams.searching = false
    dataTableParams.keys = { blurable: true }

    return dataTableParams;
}

DataTableWrapper.prototype.init= function(dataTableParams) {
    // if these properties are not set, they cannot exist in the params passed to datatable
    if (dataTableParams.hasOwnProperty('stateSaveCallback') && !dataTableParams.stateLoadCallback) { delete dataTableParams.stateSaveCallback; }
    if (dataTableParams.hasOwnProperty('stateLoadCallback') && !dataTableParams.stateLoadCallback) { delete dataTableParams.stateLoadCallback; }

    if (this.$table.length && !$.fn.DataTable.isDataTable(this.$table)) {
        this.$table
        .on('processing.dt', function(e, settings, processing) { 
            if(typeof dataTableParams.showTableLoading === "function") { 
                dataTableParams.showTableLoading(processing);
            } 
        })
        .on( 'key.dt', function ( e, datatable, key, cell, originalEvent ) {
            //console.log( 'Key press: '+key+' for cell '+cell.data() );
            if (cell && typeof cell.focus == 'function') {
                cell.focus();
            }
            switch (key) {
                // use space bar to select/deselect row when on a cell that is directly set to be focusable
                case 32:
                    var rowCount = cell.index().row;
                    var targetRow = datatable.row(rowCount);
                    var inputLength = $(cell.node()).find("input:not([type=hidden]").length;

                    if (typeof(targetRow.select)==='function' 
                        && $(cell.node()).prop('tabindex')>=0 
                        && inputLength >= 1) {
                            if ($(targetRow.node()).is('.selected')) {
                                targetRow.deselect();
                            } else {
                                targetRow.select();
                            }
                    } else {
                        if ($(datatable.table().container()).find("table").hasClass("dtr-inline collapsed") 
                        && (rowCount == 0 && inputLength <= 1) || (rowCount > 0 && inputLength < 1)) {
                            $(targetRow.node()).find(".dtr-control").click();
                        }
                    }
                    break;
                case 13:
                    var source = originalEvent.target || originalEvent.srcElement;
                    if (source.tagName == "INPUT") {
                        originalEvent.preventDefault();
                    }
            }
        } )
        .on( 'key-focus.dt', function ( e, datatable, cell ) {
            //console.log( 'Cell focus: '+cell.data() );
            var tabIndexableThing = $(':visible', cell.node()).filter(function(idx, n) {return $(n).prop('tabindex')>=0});
            if (tabIndexableThing && tabIndexableThing.length) {
                tabIndexableThing.last()[0].focus() // .last because of existence of responsive plugin leaving tabindex-able stuff in cells that should not get immediate focus if there is something else
            } else {
                $(cell.node()).prop('tabindex', 0);
                cell.node().focus();
            }
        } )
        .on( 'key-blur.dt', function ( e, datatable, cell ) {
            //console.log( 'Cell blur: '+cell.data() );
            if ($(cell.node()).prop('tabindex')>=0) {
                $(cell.node()).prop('tabindex', -1);
            }
        } )
        .on( 'page.dt', function( e, settings) {
            // clean up all popovers opened on elements in the table
            $('[aria-describedby^=popover]', this).each(function() { $('#' + $(this).attr('aria-describedby')).popover('hide') })
        })
        .DataTable(Object.assign(
            {}, 
            dataTableParams, 
            {
                initComplete: function() {
                    if (typeof dataTableParams.jsTableBuffer === "function") {
                        dataTableParams.jsTableBuffer()
                    }
                    if (typeof dataTableParams.initComplete === "function") {
                        dataTableParams.initComplete()
                    }

                    this.find('tbody td[tabindex]').removeAttr('tabindex');
                    if (dataTableParams.tableRole) {
                        $(this).attr('role', dataTableParams.tableRole);
                    }
                },
                drawCallback: function() {
                    if (typeof dataTableParams.drawCallback === "function") {
                        dataTableParams.drawCallback()
                    }
                    var previousButton = $("#DataTable_wrapper").find("#DataTable_previous.disabled > a");
                    var nextButton = $("#DataTable_wrapper").find("#DataTable_next.disabled > a");

                    if (previousButton != null){
                        previousButton.attr("tabindex", -1).prop("disabled", true)
                    }
                    if (nextButton != null){
                        nextButton.attr("tabindex", -1).prop("disabled", true)
                    }

                    var currentButton = $("li.paginate_button.active > a")
                    if (currentButton != null) {
                        currentButton.attr("aria-current","true")
                    }
                    setTimeout(function() {
                        $('.datatable-tooltip-container').find('.dt-right.dtr-control.focus').tooltip('destroy').removeClass('focus');
                    }, 10);
                }
            }
        )); // $("#DataTable")
    }
}

function DataTableParams() {
        fixedHeader = null
        responsive = null
        ordering = null
        order = null
        processing = null
        serverSide = null
        ajax = null
        columnDefs = null
        stateSave = null
        searching = null
        initComplete = null
        drawCallback = null
        language = null
        info = null
        pageLength = null
        lengthMenu = null
        deferredRender = null
        paging = null
        jsTableBuffer = null
        displayStart = null
        showTableLoading = null
        select = null
        stateSaveCallback = undefined
        stateLoadCallback = undefined
        keys = null
}
